import { Resources } from 'constants/resources';

import { ResourceProps } from 'react-admin';

import { OrderMethodsList } from './OrderMethodsList';

export const orderMethodsResource: ResourceProps = {
  name: Resources.OrderMethods,
  create: <></>,
  edit: <></>,
  list: OrderMethodsList,
  show: <></>,
};
